/* EPP mobile layer (The Evo Shop): sticky-header offset, scroll compaction, garage badge,
   collection "Read more", product-page sticky add-to-cart. Styles live in epp-mobile.css. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var root = document.documentElement;

  // Garage badge: hide while the count is 0 (epp-garage.js writes the number).
  function syncBadges() {
    document.querySelectorAll('.epp-garage-badge').forEach(function (b) {
      var t = (b.textContent || '').trim();
      if (t === '' || t === '0') b.setAttribute('data-zero', ''); else b.removeAttribute('data-zero');
    });
  }
  syncBadges();
  document.querySelectorAll('.epp-garage-badge').forEach(function (b) {
    new MutationObserver(syncBadges).observe(b, { childList: true, characterData: true, subtree: true });
  });

  // Sticky header: offset by the announcement height so only the announcement scrolls away.
  var sec = document.getElementById('shopify-section-header');
  var ann = sec && sec.querySelector('.announcement-bar');
  function setTop() {
    if (!sec) return;
    sec.style.top = mq.matches && ann ? -ann.offsetHeight + 'px' : '';
  }
  setTop();
  window.addEventListener('resize', setTop);

  // Collapse the generation chips once the visitor scrolls.
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('epp-scrolled', window.scrollY > 80);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Collection intro: clamp to 3 lines behind a "Read more" toggle.
  var intro = document.querySelector('.epp-chead .epp-intro');
  if (intro && mq.matches) {
    intro.classList.add('epp-clamp');
    if (intro.scrollHeight > intro.clientHeight + 4) {
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'epp-readmore';
      more.textContent = 'Read more';
      more.addEventListener('click', function () {
        var clamped = intro.classList.toggle('epp-clamp');
        more.textContent = clamped ? 'Read more' : 'Show less';
      });
      intro.insertAdjacentElement('afterend', more);
    } else {
      intro.classList.remove('epp-clamp');
    }
  }

  // Product page: sticky add-to-cart bar while the real button is off screen.
  var real = document.querySelector('.epp-pdp .ep-add');
  if (real && 'IntersectionObserver' in window) {
    var bar = document.createElement('div');
    bar.className = 'epp-satc';
    bar.innerHTML = '<div class="epp-satc__info"><span class="epp-satc__title"></span><span class="epp-satc__price"></span></div><button type="button" class="epp-satc__btn"></button>';
    var titleEl = document.querySelector('.epp-pdp .ep-title');
    bar.querySelector('.epp-satc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    var btn = bar.querySelector('.epp-satc__btn');
    document.body.appendChild(bar);

    // Price: the customizer TOTAL when present (includes paid options), else the headline price.
    function currentPrice() {
      var total = document.querySelector('.ep-product-options__total');
      if (total) {
        var m = (total.textContent || '').match(/[$€£]\s?[\d.,]+/);
        if (m) return m[0];
      }
      var p = document.querySelector('.epp-pdp .ep-price');
      return p && p.firstChild ? (p.firstChild.textContent || '').trim() : '';
    }
    function sync() {
      bar.querySelector('.epp-satc__price').textContent = currentPrice();
      btn.disabled = !!real.disabled;
      btn.textContent = real.disabled ? 'Sold Out' : (real.textContent || 'Add to Cart').trim();
    }
    sync();
    document.addEventListener('change', function () { setTimeout(sync, 0); });
    document.addEventListener('click', function () { setTimeout(sync, 0); });

    btn.addEventListener('click', function () {
      // Use the real button so the customizer's validation and line-item properties still apply.
      real.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { real.click(); }, 350);
    });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = mq.matches && !e.isIntersecting;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('epp-satc-pad', show);
      });
    }).observe(real);
  }
})();
